const LABEL_TO_PHRASE = {
  XlSheet: 'a spreadsheet',
  Doc: 'a document',
  APP: 'an app',
  Other: 'your own idea',
}

/**
 * @param {string} selectedAnswer
 */
export function humanizeAgentQuestionSelection(selectedAnswer) {
  const raw = String(selectedAnswer ?? '').trim()
  if (!raw) return ''
  const afterLetter = raw.includes('·') ? raw.split('·').pop().trim() : raw
  return LABEL_TO_PHRASE[afterLetter] ?? afterLetter
}

/**
 * @param {string} prompt
 * @param {string} selectedAnswer
 * @param {string | undefined} kind
 */
export function formatAgentQuestionAnswerCopy(prompt, selectedAnswer, kind) {
  const choice = humanizeAgentQuestionSelection(selectedAnswer)
  if (!choice) return ''
  if (kind === 'designDnaFigmaPublish') return ''
  return `Sounds good — we'll create ${choice}.`
}
